// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v6.30.2
// source: services/documents/document.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { Observable } from "rxjs";
import { share } from "rxjs/operators";
import { EmptyResponse } from "../../common/messages/messages";

export const protobufPackage = "services.documents";

export interface UploadChunkRequest {
  id: string;
  partNumber: number;
  body: Uint8Array;
}

export interface VerifyUploadedChunksRequest {
  id: string;
  numberOfChunks: number;
  documentType: string;
  contentType: string;
  fileName: string;
}

export interface Document {
  id: string;
  fileId: string;
  insertionTimestamp: number;
  documentType: string;
  fileType?: string | undefined;
  fileName: string;
  sha256Hash: string;
}

export interface GetFileResponse {
  fileData: Uint8Array;
  fileType: string;
}

export interface GetFileRequest {
  documentId: string;
  /** For resume support (0 = start from beginning) */
  offset: number;
}

export interface FileChunkResponse {
  /** Raw chunk bytes */
  content: Uint8Array;
  /** Byte offset of this chunk */
  offset: number;
  /** Total file size in bytes (first chunk only) */
  totalSize: number;
  /** MIME type (first chunk only) */
  mimeType: string;
  /** Original filename (first chunk only) */
  fileName: string;
  /** True on the final chunk */
  isLast: boolean;
}

export interface GetFileUrlRequest {
  documentId: string;
}

export interface GetFileUrlResponse {
  url: string;
}

export interface UploadFileRequest {
  sha256Hash: string;
  base64Sha256Hash: string;
  documentId: string;
  contentType: string;
}

export interface UploadFileResponse {
  documentOrUpload?: { $case: "document"; value: Document } | { $case: "uploadUrl"; value: string } | undefined;
}

export interface VerifyFileUploadRequest {
  documentId: string;
  documentType: string;
  contentType: string;
  fileName: string;
  contentHash: string;
}

function createBaseUploadChunkRequest(): UploadChunkRequest {
  return { id: "", partNumber: 0, body: new Uint8Array(0) };
}

export const UploadChunkRequest: MessageFns<UploadChunkRequest> = {
  encode(message: UploadChunkRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.partNumber !== 0) {
      writer.uint32(16).int32(message.partNumber);
    }
    if (message.body.length !== 0) {
      writer.uint32(26).bytes(message.body);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadChunkRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadChunkRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.partNumber = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.body = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadChunkRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      partNumber: isSet(object.partNumber)
        ? globalThis.Number(object.partNumber)
        : isSet(object.part_number)
        ? globalThis.Number(object.part_number)
        : 0,
      body: isSet(object.body) ? bytesFromBase64(object.body) : new Uint8Array(0),
    };
  },

  toJSON(message: UploadChunkRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.partNumber !== 0) {
      obj.partNumber = Math.round(message.partNumber);
    }
    if (message.body.length !== 0) {
      obj.body = base64FromBytes(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UploadChunkRequest>, I>>(base?: I): UploadChunkRequest {
    return UploadChunkRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UploadChunkRequest>, I>>(object: I): UploadChunkRequest {
    const message = createBaseUploadChunkRequest();
    message.id = object.id ?? "";
    message.partNumber = object.partNumber ?? 0;
    message.body = object.body ?? new Uint8Array(0);
    return message;
  },
};

function createBaseVerifyUploadedChunksRequest(): VerifyUploadedChunksRequest {
  return { id: "", numberOfChunks: 0, documentType: "", contentType: "", fileName: "" };
}

export const VerifyUploadedChunksRequest: MessageFns<VerifyUploadedChunksRequest> = {
  encode(message: VerifyUploadedChunksRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.numberOfChunks !== 0) {
      writer.uint32(16).int32(message.numberOfChunks);
    }
    if (message.documentType !== "") {
      writer.uint32(26).string(message.documentType);
    }
    if (message.contentType !== "") {
      writer.uint32(34).string(message.contentType);
    }
    if (message.fileName !== "") {
      writer.uint32(42).string(message.fileName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VerifyUploadedChunksRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyUploadedChunksRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.numberOfChunks = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.documentType = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.contentType = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyUploadedChunksRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      numberOfChunks: isSet(object.numberOfChunks)
        ? globalThis.Number(object.numberOfChunks)
        : isSet(object.number_of_chunks)
        ? globalThis.Number(object.number_of_chunks)
        : 0,
      documentType: isSet(object.documentType)
        ? globalThis.String(object.documentType)
        : isSet(object.document_type)
        ? globalThis.String(object.document_type)
        : "",
      contentType: isSet(object.contentType)
        ? globalThis.String(object.contentType)
        : isSet(object.content_type)
        ? globalThis.String(object.content_type)
        : "",
      fileName: isSet(object.fileName)
        ? globalThis.String(object.fileName)
        : isSet(object.file_name)
        ? globalThis.String(object.file_name)
        : "",
    };
  },

  toJSON(message: VerifyUploadedChunksRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.numberOfChunks !== 0) {
      obj.numberOfChunks = Math.round(message.numberOfChunks);
    }
    if (message.documentType !== "") {
      obj.documentType = message.documentType;
    }
    if (message.contentType !== "") {
      obj.contentType = message.contentType;
    }
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifyUploadedChunksRequest>, I>>(base?: I): VerifyUploadedChunksRequest {
    return VerifyUploadedChunksRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifyUploadedChunksRequest>, I>>(object: I): VerifyUploadedChunksRequest {
    const message = createBaseVerifyUploadedChunksRequest();
    message.id = object.id ?? "";
    message.numberOfChunks = object.numberOfChunks ?? 0;
    message.documentType = object.documentType ?? "";
    message.contentType = object.contentType ?? "";
    message.fileName = object.fileName ?? "";
    return message;
  },
};

function createBaseDocument(): Document {
  return {
    id: "",
    fileId: "",
    insertionTimestamp: 0,
    documentType: "",
    fileType: undefined,
    fileName: "",
    sha256Hash: "",
  };
}

export const Document: MessageFns<Document> = {
  encode(message: Document, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.fileId !== "") {
      writer.uint32(18).string(message.fileId);
    }
    if (message.insertionTimestamp !== 0) {
      writer.uint32(24).int64(message.insertionTimestamp);
    }
    if (message.documentType !== "") {
      writer.uint32(34).string(message.documentType);
    }
    if (message.fileType !== undefined) {
      writer.uint32(42).string(message.fileType);
    }
    if (message.fileName !== "") {
      writer.uint32(50).string(message.fileName);
    }
    if (message.sha256Hash !== "") {
      writer.uint32(58).string(message.sha256Hash);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Document {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDocument();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.insertionTimestamp = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.documentType = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fileType = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.sha256Hash = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Document {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      fileId: isSet(object.fileId)
        ? globalThis.String(object.fileId)
        : isSet(object.file_id)
        ? globalThis.String(object.file_id)
        : "",
      insertionTimestamp: isSet(object.insertionTimestamp)
        ? globalThis.Number(object.insertionTimestamp)
        : isSet(object.insertion_timestamp)
        ? globalThis.Number(object.insertion_timestamp)
        : 0,
      documentType: isSet(object.documentType)
        ? globalThis.String(object.documentType)
        : isSet(object.document_type)
        ? globalThis.String(object.document_type)
        : "",
      fileType: isSet(object.fileType)
        ? globalThis.String(object.fileType)
        : isSet(object.file_type)
        ? globalThis.String(object.file_type)
        : undefined,
      fileName: isSet(object.fileName)
        ? globalThis.String(object.fileName)
        : isSet(object.file_name)
        ? globalThis.String(object.file_name)
        : "",
      sha256Hash: isSet(object.sha256Hash)
        ? globalThis.String(object.sha256Hash)
        : isSet(object.sha256_hash)
        ? globalThis.String(object.sha256_hash)
        : "",
    };
  },

  toJSON(message: Document): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    if (message.insertionTimestamp !== 0) {
      obj.insertionTimestamp = Math.round(message.insertionTimestamp);
    }
    if (message.documentType !== "") {
      obj.documentType = message.documentType;
    }
    if (message.fileType !== undefined) {
      obj.fileType = message.fileType;
    }
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    if (message.sha256Hash !== "") {
      obj.sha256Hash = message.sha256Hash;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Document>, I>>(base?: I): Document {
    return Document.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Document>, I>>(object: I): Document {
    const message = createBaseDocument();
    message.id = object.id ?? "";
    message.fileId = object.fileId ?? "";
    message.insertionTimestamp = object.insertionTimestamp ?? 0;
    message.documentType = object.documentType ?? "";
    message.fileType = object.fileType ?? undefined;
    message.fileName = object.fileName ?? "";
    message.sha256Hash = object.sha256Hash ?? "";
    return message;
  },
};

function createBaseGetFileResponse(): GetFileResponse {
  return { fileData: new Uint8Array(0), fileType: "" };
}

export const GetFileResponse: MessageFns<GetFileResponse> = {
  encode(message: GetFileResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fileData.length !== 0) {
      writer.uint32(10).bytes(message.fileData);
    }
    if (message.fileType !== "") {
      writer.uint32(18).string(message.fileType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFileResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFileResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fileData = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fileType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFileResponse {
    return {
      fileData: isSet(object.fileData)
        ? bytesFromBase64(object.fileData)
        : isSet(object.file_data)
        ? bytesFromBase64(object.file_data)
        : new Uint8Array(0),
      fileType: isSet(object.fileType)
        ? globalThis.String(object.fileType)
        : isSet(object.file_type)
        ? globalThis.String(object.file_type)
        : "",
    };
  },

  toJSON(message: GetFileResponse): unknown {
    const obj: any = {};
    if (message.fileData.length !== 0) {
      obj.fileData = base64FromBytes(message.fileData);
    }
    if (message.fileType !== "") {
      obj.fileType = message.fileType;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFileResponse>, I>>(base?: I): GetFileResponse {
    return GetFileResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFileResponse>, I>>(object: I): GetFileResponse {
    const message = createBaseGetFileResponse();
    message.fileData = object.fileData ?? new Uint8Array(0);
    message.fileType = object.fileType ?? "";
    return message;
  },
};

function createBaseGetFileRequest(): GetFileRequest {
  return { documentId: "", offset: 0 };
}

export const GetFileRequest: MessageFns<GetFileRequest> = {
  encode(message: GetFileRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.documentId !== "") {
      writer.uint32(10).string(message.documentId);
    }
    if (message.offset !== 0) {
      writer.uint32(16).int64(message.offset);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFileRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFileRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.documentId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.offset = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFileRequest {
    return {
      documentId: isSet(object.documentId)
        ? globalThis.String(object.documentId)
        : isSet(object.document_id)
        ? globalThis.String(object.document_id)
        : "",
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : 0,
    };
  },

  toJSON(message: GetFileRequest): unknown {
    const obj: any = {};
    if (message.documentId !== "") {
      obj.documentId = message.documentId;
    }
    if (message.offset !== 0) {
      obj.offset = Math.round(message.offset);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFileRequest>, I>>(base?: I): GetFileRequest {
    return GetFileRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFileRequest>, I>>(object: I): GetFileRequest {
    const message = createBaseGetFileRequest();
    message.documentId = object.documentId ?? "";
    message.offset = object.offset ?? 0;
    return message;
  },
};

function createBaseFileChunkResponse(): FileChunkResponse {
  return { content: new Uint8Array(0), offset: 0, totalSize: 0, mimeType: "", fileName: "", isLast: false };
}

export const FileChunkResponse: MessageFns<FileChunkResponse> = {
  encode(message: FileChunkResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.content.length !== 0) {
      writer.uint32(10).bytes(message.content);
    }
    if (message.offset !== 0) {
      writer.uint32(16).int64(message.offset);
    }
    if (message.totalSize !== 0) {
      writer.uint32(24).int64(message.totalSize);
    }
    if (message.mimeType !== "") {
      writer.uint32(34).string(message.mimeType);
    }
    if (message.fileName !== "") {
      writer.uint32(42).string(message.fileName);
    }
    if (message.isLast !== false) {
      writer.uint32(48).bool(message.isLast);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FileChunkResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFileChunkResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.content = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.offset = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.totalSize = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.mimeType = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.isLast = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FileChunkResponse {
    return {
      content: isSet(object.content) ? bytesFromBase64(object.content) : new Uint8Array(0),
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : 0,
      totalSize: isSet(object.totalSize)
        ? globalThis.Number(object.totalSize)
        : isSet(object.total_size)
        ? globalThis.Number(object.total_size)
        : 0,
      mimeType: isSet(object.mimeType)
        ? globalThis.String(object.mimeType)
        : isSet(object.mime_type)
        ? globalThis.String(object.mime_type)
        : "",
      fileName: isSet(object.fileName)
        ? globalThis.String(object.fileName)
        : isSet(object.file_name)
        ? globalThis.String(object.file_name)
        : "",
      isLast: isSet(object.isLast)
        ? globalThis.Boolean(object.isLast)
        : isSet(object.is_last)
        ? globalThis.Boolean(object.is_last)
        : false,
    };
  },

  toJSON(message: FileChunkResponse): unknown {
    const obj: any = {};
    if (message.content.length !== 0) {
      obj.content = base64FromBytes(message.content);
    }
    if (message.offset !== 0) {
      obj.offset = Math.round(message.offset);
    }
    if (message.totalSize !== 0) {
      obj.totalSize = Math.round(message.totalSize);
    }
    if (message.mimeType !== "") {
      obj.mimeType = message.mimeType;
    }
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    if (message.isLast !== false) {
      obj.isLast = message.isLast;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FileChunkResponse>, I>>(base?: I): FileChunkResponse {
    return FileChunkResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FileChunkResponse>, I>>(object: I): FileChunkResponse {
    const message = createBaseFileChunkResponse();
    message.content = object.content ?? new Uint8Array(0);
    message.offset = object.offset ?? 0;
    message.totalSize = object.totalSize ?? 0;
    message.mimeType = object.mimeType ?? "";
    message.fileName = object.fileName ?? "";
    message.isLast = object.isLast ?? false;
    return message;
  },
};

function createBaseGetFileUrlRequest(): GetFileUrlRequest {
  return { documentId: "" };
}

export const GetFileUrlRequest: MessageFns<GetFileUrlRequest> = {
  encode(message: GetFileUrlRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.documentId !== "") {
      writer.uint32(10).string(message.documentId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFileUrlRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFileUrlRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.documentId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFileUrlRequest {
    return {
      documentId: isSet(object.documentId)
        ? globalThis.String(object.documentId)
        : isSet(object.document_id)
        ? globalThis.String(object.document_id)
        : "",
    };
  },

  toJSON(message: GetFileUrlRequest): unknown {
    const obj: any = {};
    if (message.documentId !== "") {
      obj.documentId = message.documentId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFileUrlRequest>, I>>(base?: I): GetFileUrlRequest {
    return GetFileUrlRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFileUrlRequest>, I>>(object: I): GetFileUrlRequest {
    const message = createBaseGetFileUrlRequest();
    message.documentId = object.documentId ?? "";
    return message;
  },
};

function createBaseGetFileUrlResponse(): GetFileUrlResponse {
  return { url: "" };
}

export const GetFileUrlResponse: MessageFns<GetFileUrlResponse> = {
  encode(message: GetFileUrlResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFileUrlResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFileUrlResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFileUrlResponse {
    return { url: isSet(object.url) ? globalThis.String(object.url) : "" };
  },

  toJSON(message: GetFileUrlResponse): unknown {
    const obj: any = {};
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFileUrlResponse>, I>>(base?: I): GetFileUrlResponse {
    return GetFileUrlResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFileUrlResponse>, I>>(object: I): GetFileUrlResponse {
    const message = createBaseGetFileUrlResponse();
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseUploadFileRequest(): UploadFileRequest {
  return { sha256Hash: "", base64Sha256Hash: "", documentId: "", contentType: "" };
}

export const UploadFileRequest: MessageFns<UploadFileRequest> = {
  encode(message: UploadFileRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sha256Hash !== "") {
      writer.uint32(10).string(message.sha256Hash);
    }
    if (message.base64Sha256Hash !== "") {
      writer.uint32(18).string(message.base64Sha256Hash);
    }
    if (message.documentId !== "") {
      writer.uint32(26).string(message.documentId);
    }
    if (message.contentType !== "") {
      writer.uint32(34).string(message.contentType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadFileRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadFileRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sha256Hash = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.base64Sha256Hash = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.documentId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.contentType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadFileRequest {
    return {
      sha256Hash: isSet(object.sha256Hash)
        ? globalThis.String(object.sha256Hash)
        : isSet(object.sha256_hash)
        ? globalThis.String(object.sha256_hash)
        : "",
      base64Sha256Hash: isSet(object.base64Sha256Hash)
        ? globalThis.String(object.base64Sha256Hash)
        : isSet(object.base64_sha256_hash)
        ? globalThis.String(object.base64_sha256_hash)
        : "",
      documentId: isSet(object.documentId)
        ? globalThis.String(object.documentId)
        : isSet(object.document_id)
        ? globalThis.String(object.document_id)
        : "",
      contentType: isSet(object.contentType)
        ? globalThis.String(object.contentType)
        : isSet(object.content_type)
        ? globalThis.String(object.content_type)
        : "",
    };
  },

  toJSON(message: UploadFileRequest): unknown {
    const obj: any = {};
    if (message.sha256Hash !== "") {
      obj.sha256Hash = message.sha256Hash;
    }
    if (message.base64Sha256Hash !== "") {
      obj.base64Sha256Hash = message.base64Sha256Hash;
    }
    if (message.documentId !== "") {
      obj.documentId = message.documentId;
    }
    if (message.contentType !== "") {
      obj.contentType = message.contentType;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UploadFileRequest>, I>>(base?: I): UploadFileRequest {
    return UploadFileRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UploadFileRequest>, I>>(object: I): UploadFileRequest {
    const message = createBaseUploadFileRequest();
    message.sha256Hash = object.sha256Hash ?? "";
    message.base64Sha256Hash = object.base64Sha256Hash ?? "";
    message.documentId = object.documentId ?? "";
    message.contentType = object.contentType ?? "";
    return message;
  },
};

function createBaseUploadFileResponse(): UploadFileResponse {
  return { documentOrUpload: undefined };
}

export const UploadFileResponse: MessageFns<UploadFileResponse> = {
  encode(message: UploadFileResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.documentOrUpload?.$case) {
      case "document":
        Document.encode(message.documentOrUpload.value, writer.uint32(10).fork()).join();
        break;
      case "uploadUrl":
        writer.uint32(18).string(message.documentOrUpload.value);
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadFileResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadFileResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.documentOrUpload = { $case: "document", value: Document.decode(reader, reader.uint32()) };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.documentOrUpload = { $case: "uploadUrl", value: reader.string() };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadFileResponse {
    return {
      documentOrUpload: isSet(object.document)
        ? { $case: "document", value: Document.fromJSON(object.document) }
        : isSet(object.uploadUrl)
        ? { $case: "uploadUrl", value: globalThis.String(object.uploadUrl) }
        : isSet(object.upload_url)
        ? { $case: "uploadUrl", value: globalThis.String(object.upload_url) }
        : undefined,
    };
  },

  toJSON(message: UploadFileResponse): unknown {
    const obj: any = {};
    if (message.documentOrUpload?.$case === "document") {
      obj.document = Document.toJSON(message.documentOrUpload.value);
    } else if (message.documentOrUpload?.$case === "uploadUrl") {
      obj.uploadUrl = message.documentOrUpload.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UploadFileResponse>, I>>(base?: I): UploadFileResponse {
    return UploadFileResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UploadFileResponse>, I>>(object: I): UploadFileResponse {
    const message = createBaseUploadFileResponse();
    switch (object.documentOrUpload?.$case) {
      case "document": {
        if (object.documentOrUpload?.value !== undefined && object.documentOrUpload?.value !== null) {
          message.documentOrUpload = { $case: "document", value: Document.fromPartial(object.documentOrUpload.value) };
        }
        break;
      }
      case "uploadUrl": {
        if (object.documentOrUpload?.value !== undefined && object.documentOrUpload?.value !== null) {
          message.documentOrUpload = { $case: "uploadUrl", value: object.documentOrUpload.value };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseVerifyFileUploadRequest(): VerifyFileUploadRequest {
  return { documentId: "", documentType: "", contentType: "", fileName: "", contentHash: "" };
}

export const VerifyFileUploadRequest: MessageFns<VerifyFileUploadRequest> = {
  encode(message: VerifyFileUploadRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.documentId !== "") {
      writer.uint32(10).string(message.documentId);
    }
    if (message.documentType !== "") {
      writer.uint32(18).string(message.documentType);
    }
    if (message.contentType !== "") {
      writer.uint32(26).string(message.contentType);
    }
    if (message.fileName !== "") {
      writer.uint32(34).string(message.fileName);
    }
    if (message.contentHash !== "") {
      writer.uint32(42).string(message.contentHash);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VerifyFileUploadRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyFileUploadRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.documentId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.documentType = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.contentType = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.contentHash = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyFileUploadRequest {
    return {
      documentId: isSet(object.documentId)
        ? globalThis.String(object.documentId)
        : isSet(object.document_id)
        ? globalThis.String(object.document_id)
        : "",
      documentType: isSet(object.documentType)
        ? globalThis.String(object.documentType)
        : isSet(object.document_type)
        ? globalThis.String(object.document_type)
        : "",
      contentType: isSet(object.contentType)
        ? globalThis.String(object.contentType)
        : isSet(object.content_type)
        ? globalThis.String(object.content_type)
        : "",
      fileName: isSet(object.fileName)
        ? globalThis.String(object.fileName)
        : isSet(object.file_name)
        ? globalThis.String(object.file_name)
        : "",
      contentHash: isSet(object.contentHash)
        ? globalThis.String(object.contentHash)
        : isSet(object.content_hash)
        ? globalThis.String(object.content_hash)
        : "",
    };
  },

  toJSON(message: VerifyFileUploadRequest): unknown {
    const obj: any = {};
    if (message.documentId !== "") {
      obj.documentId = message.documentId;
    }
    if (message.documentType !== "") {
      obj.documentType = message.documentType;
    }
    if (message.contentType !== "") {
      obj.contentType = message.contentType;
    }
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    if (message.contentHash !== "") {
      obj.contentHash = message.contentHash;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifyFileUploadRequest>, I>>(base?: I): VerifyFileUploadRequest {
    return VerifyFileUploadRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifyFileUploadRequest>, I>>(object: I): VerifyFileUploadRequest {
    const message = createBaseVerifyFileUploadRequest();
    message.documentId = object.documentId ?? "";
    message.documentType = object.documentType ?? "";
    message.contentType = object.contentType ?? "";
    message.fileName = object.fileName ?? "";
    message.contentHash = object.contentHash ?? "";
    return message;
  },
};

export interface DocumentService {
  getFile(request: DeepPartial<GetFileRequest>, metadata?: grpc.Metadata): Observable<FileChunkResponse>;
  getFileUrl(request: DeepPartial<GetFileUrlRequest>, metadata?: grpc.Metadata): Promise<GetFileUrlResponse>;
  uploadChunk(request: DeepPartial<UploadChunkRequest>, metadata?: grpc.Metadata): Promise<EmptyResponse>;
  verifyUploadedChunks(request: DeepPartial<VerifyUploadedChunksRequest>, metadata?: grpc.Metadata): Promise<Document>;
  uploadFile(request: DeepPartial<UploadFileRequest>, metadata?: grpc.Metadata): Promise<UploadFileResponse>;
  verifyUploadFile(request: DeepPartial<VerifyFileUploadRequest>, metadata?: grpc.Metadata): Promise<Document>;
}

export class DocumentServiceClientImpl implements DocumentService {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.getFile = this.getFile.bind(this);
    this.getFileUrl = this.getFileUrl.bind(this);
    this.uploadChunk = this.uploadChunk.bind(this);
    this.verifyUploadedChunks = this.verifyUploadedChunks.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.verifyUploadFile = this.verifyUploadFile.bind(this);
  }

  getFile(request: DeepPartial<GetFileRequest>, metadata?: grpc.Metadata): Observable<FileChunkResponse> {
    return this.rpc.invoke(DocumentServiceGetFileDesc, GetFileRequest.fromPartial(request), metadata);
  }

  getFileUrl(request: DeepPartial<GetFileUrlRequest>, metadata?: grpc.Metadata): Promise<GetFileUrlResponse> {
    return this.rpc.unary(DocumentServiceGetFileUrlDesc, GetFileUrlRequest.fromPartial(request), metadata);
  }

  uploadChunk(request: DeepPartial<UploadChunkRequest>, metadata?: grpc.Metadata): Promise<EmptyResponse> {
    return this.rpc.unary(DocumentServiceUploadChunkDesc, UploadChunkRequest.fromPartial(request), metadata);
  }

  verifyUploadedChunks(request: DeepPartial<VerifyUploadedChunksRequest>, metadata?: grpc.Metadata): Promise<Document> {
    return this.rpc.unary(
      DocumentServiceVerifyUploadedChunksDesc,
      VerifyUploadedChunksRequest.fromPartial(request),
      metadata,
    );
  }

  uploadFile(request: DeepPartial<UploadFileRequest>, metadata?: grpc.Metadata): Promise<UploadFileResponse> {
    return this.rpc.unary(DocumentServiceUploadFileDesc, UploadFileRequest.fromPartial(request), metadata);
  }

  verifyUploadFile(request: DeepPartial<VerifyFileUploadRequest>, metadata?: grpc.Metadata): Promise<Document> {
    return this.rpc.unary(DocumentServiceVerifyUploadFileDesc, VerifyFileUploadRequest.fromPartial(request), metadata);
  }
}

export const DocumentServiceDesc = { serviceName: "services.documents.DocumentService" };

export const DocumentServiceGetFileDesc: UnaryMethodDefinitionish = {
  methodName: "GetFile",
  service: DocumentServiceDesc,
  requestStream: false,
  responseStream: true,
  requestType: {
    serializeBinary() {
      return GetFileRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = FileChunkResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const DocumentServiceGetFileUrlDesc: UnaryMethodDefinitionish = {
  methodName: "GetFileUrl",
  service: DocumentServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetFileUrlRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetFileUrlResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const DocumentServiceUploadChunkDesc: UnaryMethodDefinitionish = {
  methodName: "UploadChunk",
  service: DocumentServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UploadChunkRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = EmptyResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const DocumentServiceVerifyUploadedChunksDesc: UnaryMethodDefinitionish = {
  methodName: "VerifyUploadedChunks",
  service: DocumentServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return VerifyUploadedChunksRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = Document.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const DocumentServiceUploadFileDesc: UnaryMethodDefinitionish = {
  methodName: "UploadFile",
  service: DocumentServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UploadFileRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = UploadFileResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const DocumentServiceVerifyUploadFileDesc: UnaryMethodDefinitionish = {
  methodName: "VerifyUploadFile",
  service: DocumentServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return VerifyFileUploadRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = Document.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any>;
  invoke<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;
    streamingTransport?: grpc.TransportFactory;
    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;
      streamingTransport?: grpc.TransportFactory;
      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Promise((resolve, reject) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: function (response) {
          if (response.status === grpc.Code.OK) {
            resolve(response.message!.toObject());
          } else {
            const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
            reject(err);
          }
        },
      });
    });
  }

  invoke<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any> {
    const upStreamCodes = this.options.upStreamRetryCodes ?? [];
    const DEFAULT_TIMEOUT_TIME: number = 3_000;
    const request = { ..._request, ...methodDesc.requestType };
    const transport = this.options.streamingTransport ?? this.options.transport;
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Observable((observer) => {
      const upStream = () => {
        const client = grpc.invoke(methodDesc, {
          host: this.host,
          request,
          ...(transport !== undefined ? { transport } : {}),
          metadata: maybeCombinedMetadata ?? {},
          debug: this.options.debug ?? false,
          onMessage: (next) => observer.next(next),
          onEnd: (code: grpc.Code, message: string, trailers: grpc.Metadata) => {
            if (code === 0) {
              observer.complete();
            } else if (upStreamCodes.includes(code)) {
              setTimeout(upStream, DEFAULT_TIMEOUT_TIME);
            } else {
              const err = new Error(message) as any;
              err.code = code;
              err.metadata = trailers;
              observer.error(err);
            }
          },
        });
        observer.add(() => client.close());
      };
      upStream();
    }).pipe(share());
  }
}

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
